import { useAuth } from '../context/AuthContext';
import { canUseKioAgent } from '../utils/subscriptionPlan';

/** Le compte connecté (ou le propriétaire de la boutique pour un staff) a-t-il accès à KIOAGENT ? */
export function useKioAgentAccess() {
  const { user } = useAuth();
  return canUseKioAgent(user);
}
